export const switchEndpoint = "https://api.staging.switchrecycling.com/api/v1";
